import HomeAssumptionsZurichRentPage from './HomeAssumptionsZurichRentPage';

export default HomeAssumptionsZurichRentPage;
